import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from "@mui/material";
import packagejson from "../../../../package.json";
import Logo from "../../../assets/images/logo_medium.png";
import { StyledDialog } from "../../styled/dialog";
import CustomDialog from "../dialog/customDialog";

export default function AboutDialog({ open, onClose }) {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dismissible
    >
      <DialogTitle
        disableTypography
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "default",
        }}>
        <StyledDialog.Title>Acerca de...</StyledDialog.Title>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description">
          <StyledDialog.Container>
            <img src={Logo} alt="" />
            <p>
              <b>Versión {packagejson.version}</b>
            </p>
            <div>
              Copyright © 1998 - {new Date().getFullYear()}. Access Informática
              S.R.L.
            </div>
            <div>Todos los derechos reservados.</div>
          </StyledDialog.Container>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Aceptar
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}
